import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { type InboxActions, InternalInboxActions } from '../actions'
import { inboxClient } from '../client'

// Read locally first, so the row greys out and the badge drops at once
export function* markRead({
  payload: { workspace, ids },
}: ReturnType<typeof InboxActions.markRead>) {
  if (ids.length === 0) {
    return
  }

  yield put(InternalInboxActions.readLocally({ workspace, ids }))

  try {
    yield call(inboxClient.markRead, ids)
  } catch (error) {
    console.error('Error marking inbox rows read:', error)

    yield put(GeneralErrorNotification)
  }
}

export function* markAllRead({
  payload: { workspace },
}: ReturnType<typeof InboxActions.markAllRead>) {
  yield put(InternalInboxActions.allReadLocally({ workspace }))

  try {
    yield call(inboxClient.markAllRead, workspace)
  } catch (error) {
    console.error('Error marking the inbox read:', error)

    yield put(GeneralErrorNotification)
  }
}
